<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8 2.375C8.34518 2.375 8.625 2.65482 8.625 3V7.375H13C13.3452 7.375 13.625 7.65482 13.625 8C13.625 8.34518 13.3452 8.625 13 8.625H8.625V13C8.625 13.3452 8.34518 13.625 8 13.625C7.65482 13.625 7.375 13.3452 7.375 13V8.625H3C2.65482 8.625 2.375 8.34518 2.375 8C2.375 7.65482 2.65482 7.375 3 7.375H7.375V3C7.375 2.65482 7.65482 2.375 8 2.375Z" fill="currentColor"/>
  </svg>
</template>

<script setup lang="ts">

</script>
